import { render, staticRenderFns } from "./image-icon.vue?vue&type=template&id=562e86b8&"
import script from "./image-icon.vue?vue&type=script&lang=js&"
export * from "./image-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports